import React from 'react';

export type SelectableListValue = string | number | null;

export type SelectableListContextType = {
  value: SelectableListValue;
  onChange: (value: SelectableListValue) => void;
};

export const SelectableListContext = React.createContext<SelectableListContextType>({
  value: '',
  onChange: (_value: SelectableListValue) => void 0,
});


export const useSelectableListContext = () => React.useContext(SelectableListContext);
